__turbopack_context__.v({
  "bannerLogo": "Home-module__gwzlta__bannerLogo",
  "chartsGrid": "Home-module__gwzlta__chartsGrid",
  "chartsRow": "Home-module__gwzlta__chartsRow",
  "container": "Home-module__gwzlta__container",
  "grid": "Home-module__gwzlta__grid",
  "gridWithDivider": "Home-module__gwzlta__gridWithDivider",
  "leftColumn": "Home-module__gwzlta__leftColumn",
  "pageTitle": "Home-module__gwzlta__pageTitle",
  "pageTitleBanner": "Home-module__gwzlta__pageTitleBanner",
  "pageTitleContent": "Home-module__gwzlta__pageTitleContent",
  "placeholder": "Home-module__gwzlta__placeholder",
  "rightColumn": "Home-module__gwzlta__rightColumn",
  "topSection": "Home-module__gwzlta__topSection",
  "verticalDivider": "Home-module__gwzlta__verticalDivider",
});
